<script lang="ts">
	import { getContext } from 'svelte';
	import type { ContentInfo } from './InfoQuery';
	import LinkButton from '@comp/LinkButton.svelte';
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import { createViewController, ViewController } from '$lib/actions/animations/ViewController';

	let { data, theme = 'dark' }: { data: ContentInfo; theme?: string } = $props();

	let pStyle = $state(
		data.description.length > 65 ? 'text:description-large' : 'text:headline-large'
	);
	let hStyle = $state('text:description-small');
	const layout = getContext('content-layout') ?? 'default';
	const useDot = layout !== 'fullbleed';

	if (layout === 'fullbleed') {
		pStyle = 'text:description';
		hStyle = 'text:headline';
	}
	createViewController();
</script>

<div class="container theme-{theme}" use:ViewController>
	<h3 class={hStyle} use:EnterOnView>
		{#if useDot}
			<span class="dot theme-{theme}"></span>
		{/if}
		{data.eyebrow}
	</h3>
	<p class={pStyle} use:EnterOnView={{ delay: 0.15 }}>{data.description}</p>
	{#if data.link}
		<div class="cta" use:EnterOnView={{ delay: 0.3 }}>
			<LinkButton link={data.link} variant="primary"></LinkButton>
		</div>
	{/if}
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;

		.cta {
			margin-top: 32px;
			display: flex;
			@include md {
				margin-top: 40px;
			}
		}

		:global([data-button]) {
			color: hsl(var(--color-background));
			border: 1px solid hsl(var(--color-background));
		}
		&.theme-light {
			:global([data-button]) {
				color: hsl(var(--color-foreground));
				border: 1px solid hsl(var(--color-foreground));

				&:hover {
					background-color: hsl(var(--color-foreground));
					color: hsl(var(--color-primary));
				}
			}
		}
		&.theme-faded {
			:global([data-button]) {
				color: hsl(var(--color-foreground));
				border: 1px solid hsl(var(--color-foreground));

				&:hover {
					color: hsl(var(--color-backgroundMuted));
				}
			}
		}

		p {
			max-width: 510px;
			&:last-child {
				padding-bottom: 80px;
			}
		}
	}

	.dot {
		background-color: hsl(var(--color-primary));

		width: 10px;
		height: 10px;
		border-radius: 50%;
		display: inline-block;
		margin-right: 20px;

		&.theme-light {
			background-color: hsl(var(--color-foreground));
		}
	}

	h3 {
		padding-bottom: 40px;
	}
</style>
